import { Dispatch } from 'redux';
import { LoginService } from "../../services/LoginService";
import { adminapi } from "../../ApiNames";

type Nullable<T> = T | null;

export const fetchdatasuccess = (data:any)=>({
    type : 'fetch_data_success',
    payload:data
})
export const fetchDataViewSuccess = (viewdata: any) => ({
    type: 'FETCH_VIEW_DATA_SUCCESS',
    payload: viewdata,
});
export const fetchdocdata = (docdata: any) => ({
    type: 'VIEW_DATA_SUCCESS',
    payload: docdata,
});
export const fetchdata = (orgID:any)=>{
    return async (dispatch:Dispatch) =>{
        try{
            const payload = {need:orgID,q:2};
            const apiname = adminapi.ad_donordocument
            const response = await LoginService.getData(apiname,payload);
            dispatch(fetchdatasuccess(response));
        }catch(error) {
            console.error('Error fetching data:', error);
        }
    }
}
export const fetchviewdata = (orgID:any)=>{
    return async (dispatch:Dispatch) =>{
        try{
            const payload = {userid:orgID,q:2};
            const apiname = adminapi.ad_orgdocument
            const response = await LoginService.getData(apiname,payload);
            dispatch(fetchDataViewSuccess(response));
        }catch(error) {
            console.error('Error fetching data:', error);
        }
    }
}

export const fetchviewDoc = ( DocID:string) => {
    return async (dispatch: Dispatch) => {
        try {
            const payload = { q: 4,did:DocID};
            const apiname = adminapi.ad_docview;
            const response = await LoginService.getData(apiname,payload);
            dispatch(fetchdocdata(response));
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
};